import Hero from "../../components/Hero/Hero";
import Footer from "../../components/Footer/Footer";
import Trip from "../../components/Trip/Trip";

const AboutImg =
  "https://images.unsplash.com/photo-1621932945904-c5be9be992d8?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=765&q=80";

function Service() {
  return (
    <div>
      <Hero
        cName="hero-mid"
        heroImg={AboutImg}
        title="Service"
        btnClass="hide"
      />
      <Trip />
      <Footer />
    </div>
  );
}

export default Service;
